import { Swiper, SwiperOptions, Autoplay, Navigation, EffectFade } from 'swiper'
import { constVoid, DOM, IOO, pipe, RR, s, v } from '@packages/prelude'
import '../css/main.scss'
import 'bootstrap'

const makeSwiper = (selector: string, options: SwiperOptions) =>
  pipe(
    IOO.of({ document }),
    IOO.chain(({ document }) => pipe(document, DOM.querySelector(`#${selector}`)) as IOO.IOOption<HTMLElement>),
    IOO.fold(
      () => constVoid,
      element => IOO.of(new Swiper(element, options))
    )
  )()

const Swipers: Record<string, SwiperOptions> = {
  partnerLogoSlider: {
    slidesPerView: 2,
    slidesPerGroup: 1,
    modules: [Autoplay],
    breakpoints: {
      768: {
        slidesPerView: 3,
        slidesPerGroup: 1
      },
      1000: {
        slidesPerView: 4,
        slidesPerGroup: 1
      },
      1300: {
        slidesPerView: 5,
        slidesPerGroup: 1
      }
    },
    loop: true,
    autoplay: {
      delay: 2000
    },
    speed: 1000
  },
  heroSlider: {
    slidesPerView: 1,
    modules: [Navigation, EffectFade],
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    loop: true,
    allowTouchMove: false,
    navigation: {
      nextEl: '.swiper-btn-next',
      prevEl: '.swiper-btn-prev'
    }
  }
}

pipe(
  Swipers,
  RR.foldMapWithIndex(s.Ord)(v.Monoid)((selector, options) => makeSwiper(selector, options))
)
